import _ from 'lodash';
import { prepareAccountModelAdapter } from '../../../../../common/adapter/randomDataAccountAdapter';
import { BaseController } from '../../../../../common/base/controller';
import { DATA_GENERATOR_CONFIG } from './dataGenerator';
import { toUtcMidnight } from '../../../../../common/helper/date';

export class ReceivingCreateRequestController extends BaseController {
  constructor(
    $scope,
    $compile,
    hotkeys,
    fdFormFieldsService,
    controllerService,
    dataParser,
    ticketsService,
    receivingService,
    receivingCreateRequestService,
    needsConfirmationService,
    hotkeyService,
    modalActionService,
    notificationService,
    dataGenerator,
    atruviaUserDataModalService,
  ) {
    'ngInject';
    super({
      $scope,
      $compile,
      hotkeys,
      fdFormFieldsService,
      controllerService,
      dataParser,
      ticketsService,
      receivingService,
      receivingCreateRequestService,
      needsConfirmationService,
      hotkeyService,
      modalActionService,
      notificationService,
      dataGenerator,
      atruviaUserDataModalService,
    });
  }

  get ticketId() {
    return this.$stateParams.ticketId;
  }

  get isNachlass() {
    return this.$stateParams.nachlass && this.$stateParams.nachlass === 'true';
  }

  get title() {
    return this.isNachlass
      ? 'app.receiving.createRequestNachlass'
      : 'app.receiving.createRequest';
  }

  get ticketOverviewUrlWithParams() {
    return this.$state.href('app.receiving.list', { searchTerm: this.ibans });
  }

  get form() {
    return this.receivingCreateRequestForm;
  }

  get isNotProduction() {
    return !this.envService.isProduction();
  }

  set form(value) {
    this.receivingCreateRequestForm = value;
  }

  get showAccountswitchDateOnCollisionModal() {
    return this.isFeatureActive(
      this.FeatureNames
        .FF_SHOW_ACCOUNTSWITCH_DATE_ON_CREATE_REQUEST_COLLISION_MODAL,
    );
  }

  get precheckInformCustomerCheckboxes() {
    return this.isFeatureActive(
      this.FeatureNames.FF_PRECHECK_INFORM_CUSTOMER_CHECKBOX_ON_WARRANT_FORM,
    );
  }

  demo() {
    this.fillRandomData();
  }

  $onInit() {
    // Assign
    this.model = {};
    this.breadcrumbs = this.receivingService.states;
    this.branchIds = this.userService.getBranchIds() || [];

    // Apply maybe resolved ticket to the model
    if (this.ticket) {
      angular.extend(this.model, this.ticket.formValues);
    }

    this.formSetup();
    this.hotkeyService.bindHotkeys(this, this.fillRandomData.bind(this));
    if (
      this.isFeatureActive(this.FeatureNames.FF_GET_PERSONENDATEN_FROM_ATRUVIA)
    ) {
      this.atruviaUserDataModalService.openModal().result.then((result) => {
        this.model.newIban = result.newIban;
        this.model.oldIban = result.oldIban;

        this.stashedPersonNumber = result.stashedPersonNumber;

        if (!result.additionalAccountOwners.length) {
          this.canNotAddAdditionalAccountOwners = true;
        }
        if (result.hasMultipleAccountHolder) {
          this.doNotShowBirthday = true;
        }
        this._applyPersonendaten(result);

        this.model.emailAddress = result.email;

        if (result.firstName && result.hasMultipleAccountHolder) {
          this.model.firstName = result.firstName;
          this.model.lastName = result.lastName;
        }
      });
    }
  }

  _applyPersonendaten(data) {
    const primary = data.primary;

    this.model.firstName = primary.firstName;
    this.model.lastName = primary.lastName;
    this.model.birthday = toUtcMidnight(primary.dateOfBirth);

    if (primary.address) {
      this.model.address = primary.address.Strasse;
      this.model.postcode = primary.address.PLZ;
      this.model.city = primary.address.Ort;
    }

    this.model.additionalAccountOwners = data.additionalAccountOwners.map(
      (p) => ({
        firstName: p.firstName,
        lastName: p.lastName,
        birthDate: p.dateOfBirth,
      }),
    );
  }

  formSetup() {
    this.loadForm();

    this.$timeout(() => {
      this.runFormRuler();

      if (this.precheckInformCustomerCheckboxes) {
        [
          'informCustomerDeposits',
          'informCustomerStandingOrders',
          'informCustomerDebits',
        ].forEach((key) => (this.model[key] = true));
      }
    });
  }

  loadForm() {
    const prefilled = this.appCache.get('duplicateTicket');

    if (prefilled) {
      const maybeEmailAddressCustomer = sessionStorage.getItem(
        'emailAddressCustomer',
      );
      this.model.emailAddress = maybeEmailAddressCustomer;

      _.assign(this.model, prefilled);
    }
  }

  clearFormValues() {
    this.appCache.remove('duplicateTicket');
  }

  runFormRuler() {
    const { $scope, $compile, receivingCreateRequestService, model, form } =
      this;
    const injections = { $scope, $compile };

    const formRules = receivingCreateRequestService.formRules;

    // Watch every model value which has a defined form rule
    _.forEach(formRules, (rule, key) => {
      const callback = rule.create(form, model, key, injections);
      $scope.$watch(`vm.model.${key}`, (newVal, oldVal) => {
        if (newVal === oldVal) return;
        callback(newVal, oldVal);
      });
    });
  }

  reset() {
    this.fdFormFieldsService.resetFields(this.form);
    this.clearFormValues();
  }

  // dont remove this. otherwise maybe stored data like 'duplicateTicket' dont get removed when leaving warrant form without submission
  $onDestroy() {
    this.reset();
  }

  submit() {
    const { ticketId } = this;
    this.model.isNachlass = !!this.isNachlass;
    let model = this.prepareModelBeforeValidation(this.model);
    this.isAdvancedSettingsOpen = false;

    this.fdFormFieldsService
      .validate(this.form)
      .busy(this, 'isSubmitBusy')
      .then(() => {
        if (
          !this.modalActionService.showNothingIncludedDialog(
            this,
            model,
            ticketId,
          )
        ) {
          this.submitTicket(
            model,
            ticketId,
            false,
            true,
            this.stashedPersonNumber,
          );
        }
      })
      .catch((err) => {
        this.isAdvancedSettingsOpen = true;
        this.$scope.$broadcast('form:validate');
      });
  }

  submitTicket(model, ticketId, force, silent, stashedPersonNumber) {
    const data = this.prepareModelAfterValidation(model);
    if (!this.isFeatureActive(this.FeatureNames.FF_DUPLICATE_TICKET_WARNING)) {
      force = true;
    }
    this.ticketsService
      .createOrUpdate(data, ticketId, force, silent, stashedPersonNumber)
      .then((ticketId) => {
        this.clearFormValues();
        let stateName = this.receivingService.nextState(this.stateIndex);
        this.go(stateName, { ticketId });
      })
      .catch((nope) => {
        if (
          this.isFeatureActive(this.FeatureNames.FF_DUPLICATE_TICKET_WARNING) &&
          nope.status === 412
        ) {
          this.modalActionService.showDuplicatedTicketDialog(
            this,
            model,
            ticketId,
            nope.data,
          );
        }

        if (nope.status === 422) {
          if (nope.data.error === 'newIBANMismatchBIC') {
            this.notificationService.error(
              'receiving.createRequest.form.error.newIBANMismatchBIC',
            );
          }
          if (nope.data.error === 'CantShipToIBANSCountryCode') {
            this.notificationService.error(
              'receiving.createRequest.form.error.CantShipToIBANSCountryCode',
            );
          }

          if (
            nope.data.errors &&
            nope.data.errors[0] &&
            nope.data.errors[0] === 'newIban IBAN validation failed'
          ) {
            this.notificationService.error(
              'receiving.createRequest.form.error.newIBANIsInvalid',
            );
          }
        }
      });
  }

  prepareModelBeforeValidation(model) {
    // Unflatten model keys with a dot inside
    // e.g. {"foo.bar":false} --> {foot:{bar:false}}
    return this.dataParser.unflatten(model);
  }

  fillRandomData() {
    if (this.envService.isProduction()) {
      return;
    }
    this.model.isDemoData = true;
    _.map(DATA_GENERATOR_CONFIG(this.envService.countryCode), (field) => {
      const generated = this.dataGenerator.generate(field);
      this.model[field.name] = generated;
    });
  }

  prepareModelAfterValidation(model) {
    if (model.emailAddress) {
      sessionStorage.setItem('emailAddressCustomer', model.emailAddress);
    }

    return prepareAccountModelAdapter(model);
  }
}
